<template>
  <div class="row s12 full-height background-spacing-color no-border">
    <div class="row white-background center-align z-depth-3 no-border">

      <!-- Disclaimer Screen -->
      <div>
        <div class="row page-body-height">
          <div class="app-body-height">
            <div class="row">
              <div class="col s12">
                <div class="card-padding left-align">
                    <h5 class="blue-color">{{ $t('views.login.termsofserviceheader') }}</h5>
                    <p>Please read our Terms Of Service carefully and<br>decide on accepting them</p>
                      <div class="card background-spacing-color card-content-height z-depth-0">
                        <div class="card-content card-content-scroll left-align">
                          <div><p>Copyright © 2000-{{ new Date().getFullYear() }} Strukton Systems, The Netherlands.<br>
                          All Rights Reserved.<br>
                          <br>
                          <b>Ownership</b><br>
                          All software and related items, including but not limited to, Text, Graphics, Script, Data or Code concerning the POSS website or the POSS programs (further called The Software) are copyright by Strukton Systems.<br>
                          The Software is made available for the presentation and download of measured data, solely for use by the client and its representatives (further called The User) according to the License Agreement, Strukton Systems will keep the ownership of The Software. Any reproduction, redistribution, copying, modification, merger, publishing, sublicensing and/or selling of the Software, not in accordance with the License Agreement, is expressly prohibited.<br>
                          <br>
                          <b>Use of service</b><br>
                          Only the use of measured data and analysed data by POSS is permitted for The User, this includes the downloading and handling of the data in any sort of way. Where prior permission must be obtained for the reproduction or use of The Software, such permission shall cancel the above-mentioned general permission and shall clearly indicate any restrictions on use.<br>
                          <br>
                          <b>Password</b><br>
                          Some of the Services require The User to open an account; The User must complete the registration process by providing Strukton Systems with current, complete and accurate information as prompted by the applicable registration. The User will be given a password and a username. The User is entirely responsible for maintaining the confidentiality of the user's password and user's account. Furthermore, The User is entirely responsible for any and all activities that occur under the user's account.<br>
                          The User agrees to notify the Strukton Systems POSS team immediately of any unauthorized use of The User's account or any other breach of security. Strukton Systems will not be liable for any loss that The User may incur as a result of someone else using its password or account, either with or without The User's knowledge. However, The User could be held liable for losses incurred by Strukton Systems or another party due to someone else using The User's account or password. The User may not use anyone else's account at any time, without the permission of the account holder.<br>
                          <br>
                          <b>Limitation on Warranties</b><br>
                          The Software is provided by Strukton Systems "as is" and any express or implied warranties, including, but not limited to, the implied warranties of merchantability and fitness for a particular purpose are disclaimed. In no event shall Strukton Systems be liable for any direct, indirect, incidental, special, exemplary, or consequential damages (including, but not limited to, procurement of substitute goods or services; loss of use, data, or profits; or business interruption) however caused and on any theory of liability, whether in contract, strict liability, or tort (including negligence or otherwise) arising in any way out of the use of The Software, even if advised of the possibility of such damage.<br>
                          <br>
                          <b>Limitation on Liability</b><br>
                          In no event will Strukton Systems be liable to any party for any direct, indirect, special or consequential<br>
                          damages for any use of the POSS site, or on any other hyperlinked web site, including, without limitation,<br>
                          any lost profits, business interruption, loss of programs or other data on your information handling system or<br>
                          otherwise, even if Strukton Systems is expressly advised of the possibility of such damages.<br>
                          </p></div>
                        </div>
                      </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="showFirstTimeButtons">
              <div
                v-if="error"
                class="col s12 login-error helper-text">
                <div>{{ error }}</div>&nbsp;&nbsp;&nbsp;
                <i class="material-icons">warning</i>
              </div>
            </div>
          </div>
            <div v-if="showFirstTimeButtons" class="app-footer-height valign-wrapper">
              <div class="row button-padding">
                <div class="col s12">
                  <a
                    @click="acceptDisclaimer()"
                    class="waves-effect waves-light btn agree-button">{{ $t('views.login.agree') }}</a>
                  <a
                    @click="disposeDisclaimer()"
                    class="waves-effect btn-flat blue-color">{{ $t('views.login.disagree') }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// Left side
import router from '../../router'
import AuthenticationService from '../../services/AuthenticationService'

// Right side
export default {
  props: {
    showFirstTimeButtons: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      error: 'To use POSS you are required to agree with the Terms of Service'
    }
  },
  methods: {
    acceptDisclaimer: function () {
      var loginUser = AuthenticationService.getUser()

      AuthenticationService.acceptDisclaimerSso(
        loginUser
      ).then(() => {
        router.push({name: 'LoadData'})
      }).catch(e => {
        if (e.response && e.response.status === 401) {
          this.error = 'views.login.invalid'
        } else {
          this.error = e + ''
        }
      })
    },
    disposeDisclaimer: function () {
      // router.push({name: 'Root'})
      AuthenticationService.logOut()
    }
  },
  beforeMount () {

  },
  watch: {
  }
}
</script>

<style>
  .button-padding {
    padding-top: 10px;
  }

  .agree-button {
    background-color: #56CCF2;
    min-width: 94px;
  }

  .page-body-height {
    height: 100%;
  }

  .login-error {
    font-size: 12px;
    color:red;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .error-padding {
    padding-left: 45px;
    padding-right: 45px;
  }

  .card-padding {
    padding-top: 8px;
    padding-left: 45px;
    padding-right: 45px;
  }

  .card-content-scroll {
    color: black;
    overflow-y: scroll;
    height: 100%;
    resize: none;
  }
  .card-content-height {
    height: 300px;
  }

  .grey-color {
    color: rgba(0, 0, 0, 0.38);
  }

  .blue-color {
    color: #56CCF2;
  }

  h5 {
    font-size: 24px;
    font-family:Roboto;
    font-weight: 200;
    font-style: normal;
    line-height: normal;
  }
  p {
    font-family:Roboto;
    font-weight: 100;
  }

  .white-background {
    background-color: white;
  }

  .no-border {
    border: none;
    border-bottom: none;
  }

  .no-margin {
    margin: 0px;
  }

  .no-margin-bottom {
    margin-bottom: 0px;
  }

  .no-padding-left {
    padding-left: 0px !important;
  }

  .no-padding-right {
    padding-right: 0px;
  }

  .app-body-height {
     max-height: 100%;;
  }

  *:focus {
    outline: 0;
  }

  .iagree-button {
    background-color: #56CCF2;
    min-width: 94px;
  }

  .box-size-full {
    width: 806px;
    height: 592px;
  }

  .background-spacing-color {
    background-color: #F2F2F2;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/Disclaimer.vue